import "moment-timezone";
import React, { Component } from "react";
import { Modal } from 'react-bootstrap';
import EditForm from './EditForm';



class EditModal extends Component {
  render() {
    const { lead, showModal, onConfirmModal, onCloseModal } = this.props
    return (
      <Modal show={showModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Deal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditForm lead={lead} onCancelSubmit={onCloseModal} onSubmit={onConfirmModal} />
        </Modal.Body>
      </Modal>)
  }
}

export default EditModal